module.exports = __webpack_public_path__ + "530b4ea67422d8a8863829da55e70b7a.svg";